export const timespanOptions = [
  { value: "2025", label: "2025" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
  { value: "2022", label: "2022" },
  { value: "all", label: "All" },
];

const dummyData = [
  { month: "Jan", captures: 100 },
  { month: "Feb", captures: 221 },
  { month: "Mar", captures: 300 },
  { month: "Apr", captures: 600 },
  { month: "May", captures: 900 },
  { month: "June", captures: 1100 },
  { month: "July", captures: 1000 },
  { month: "Aug", captures: 600 },
  { month: "Sep", captures: 500 },
  { month: "Oct", captures: 400 },
  { month: "Nov", captures: 900 },
  { month: "Dec", captures: 1000 },
];
